import { observer } from 'mobx-react-lite';
import React, { useTransition } from 'react';
import { basedAxios } from '../../store/Store';
import cx from 'classnames';
import LoadingSkeleton from './components/LoadingSkeleton';
import SortByMenu from './components/SortByMenu';
import ExhibitorCard from './components/ExhibitorCard';
import cn from 'classnames';

interface IExhibitorListProps {
  environment: {
    eventId: string;
    lang: string;
  } & unknown;
  settings: {
    displayType: string;
    sortBy: string;
    fields: string[];
  };
}

function ExhibitorList({ environment, settings }: IExhibitorListProps) {
  const ref = React.useRef(null);
  const [searchTerm, setSearchTerm] = React.useState('');
  const [sortBy, setSortBy] = React.useState('name');
  const [exhibitorList, setExhibitorList] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isPending, startTransition] = useTransition();

  const { lang } = environment;
  const { fields = [] } = settings;

  React.useEffect(() => {
    async function fetchOrders() {
      setIsLoading(true);

      try {
        const response = await basedAxios.get('./exhibitor/partial/' + environment.eventId);

        setExhibitorList(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    }

    fetchOrders();
  }, []);

  const filteredExhibitorList = exhibitorList?.filter((exhibitor: any) => {
    return exhibitor.name?.toLowerCase().includes(searchTerm?.toLowerCase());
  });

  const sortedExhibitorList = filteredExhibitorList?.sort((a: any, b: any) => {
    if (sortBy === 'name') {
      return a.name.localeCompare(b.name);
    }
    return 0;
  });

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (filteredExhibitorList?.length > 100) {
      startTransition(() => {
        setSearchTerm(e.target.value);
      });
    } else {
      setSearchTerm(e.target.value);
    }
  };

  const handleSortBy = (sortBy: string) => {
    if (filteredExhibitorList?.length > 100) {
      startTransition(() => {
        setSortBy(sortBy);
      });
    } else {
      setSortBy(sortBy);
    }
  };

  const columnnizedExhibitorList = sortedExhibitorList?.reduce((acc: any, curr: any, index: number) => {
    const colIndex = index % 2;
    acc[colIndex] = [...(acc[colIndex] || []), curr];
    return acc;
  }, []);

  return (
    <div ref={ref} className="flex flex-col gap-y-4 w-full z-0">
      <div className="flex lg:items-center lg:flex-row flex-col lg:justify-start items-start gap-2">
        <div className="input w-full flex items-center  bg-white  relative rounded-md overflow-hidden">
          <i className="ri-search-2-line absolute top-1/2 left-3 transform text-sm -translate-y-1/2 font-normal text-slate-800"></i>
          <input className="w-full ml-6 font-normal text-sm h-[36px]" type="text" onChange={handleSearch} />
        </div>

        {/* <SortByMenu sortBy={sortBy} onChange={handleSortBy} /> */}
      </div>

      {isLoading || isPending ? (
        <LoadingSkeleton displayType={'grid'} />
      ) : (
        <div className={cx('w-full overflow-hidden  overflow-y-visble rounded-md ', `flex flex-wrap  gap-2`)}>
          {columnnizedExhibitorList?.map((exhibitor: any, index: number) => (
            <div
              key={index}
              className={cn(
                'flex flex-col gap-y-4  items-center justify-start ',
                columnnizedExhibitorList.length < 2 ? 'm-0' : 'mx-auto',
                ref.current?.clientWidth < 600 ? 'w-full' : 'w-[calc(50%_-_0.5rem)]'
              )}
            >
              {exhibitor?.map((exhibitor: any) => (
                <ExhibitorCard key={exhibitor.orderId} lang={lang} fields={fields} exhibitor={exhibitor} />
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default observer(ExhibitorList);
